import styled from 'styled-components';
import { COLORS } from '@/theme';

export const StyledBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 0.25rem 0.75rem;
  min-height: 1.5rem;
  gap: 0.5rem;
  border-radius: 1.6rem;
  border: 1px solid ${COLORS.BRIGHT_GRAY};
  background: ${COLORS.GRAY};
`;

export const StyledIndicator = styled.div<{ $color: string }>`
  border-radius: 50%;
  height: 0.75rem;
  width: 0.75rem;
  background: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const StyledText = styled.span`
  white-space: normal;
`;
